<script>
import { mapActions, mapGetters } from 'vuex'
import * as dropin from 'braintree-web-drop-in'

export default {
  props: {
    braintreeToken: {
      type: String,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
    tableNumber: {
      type: Number,
      required: true,
    },
    total: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    instance: null,
    payEnabled: false,
  }),
  computed: {
    ...mapGetters({
      loading: 'payment/getLoading',
    }),
  },
  mounted() {
    const token = this.braintreeToken
    const total = this.total
    const recipientName = this.tableNumber
      ? `Table ${this.tableNumber}, ${location}`
      : `${location}`

    dropin
      .create({
        paymentOptionPriority: ['card', 'applePay', 'googlePay'],
        authorization: token,
        container: '.dropin-container',
        dataCollector: {
          kount: true,
        },
        applePay: {
          displayName: recipientName,
          paymentRequest: {
            total: {
              label: 'Basket Total',
              amount: total,
            },
          },
        },
        // googlePay: {
        //   googlePayVersion: 2,
        //   merchantId: process.env.VUE_APP_GOOGLE_MERCHANT_ID,
        //   transactionInfo: {
        //     totalPriceStatus: 'FINAL',
        //     totalPrice: total,
        //     currencyCode: 'GBP',
        //   },
        // },
      })
      .then((instance) => {
        this.instance = instance

        this.instance.on(
          'paymentMethodRequestable',
          ({ paymentMethodIsSelected, type }) => {
            if (paymentMethodIsSelected && type !== 'CreditCard') {
              this.makePayment()
            }
            this.payEnabled = true
          }
        )

        this.instance.on(
          'paymentOptionSelected',
          ({ paymentMethodRequestable, paymentOption }) => {
            this.payEnabled =
              paymentOption === 'card' && paymentMethodRequestable
          }
        )

        this.instance.on('noPaymentMethodRequestable', () => {
          this.payEnabled = false
        })
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
      })
  },
  methods: {
    ...mapActions({
      makePayment: 'payment/makePayment',
    }),
    onClick() {
      this.instance.requestPaymentMethod(this.handlePaymentSubmit)
    },
    handlePaymentSubmit(requestPaymentMethodErr, payload) {
      if (requestPaymentMethodErr) {
        // eslint-disable-next-line no-console
        console.log({ requestPaymentMethodErr, payload })
        this.instance.clearSelectedPaymentMethod()
        this.$router.push('/failure')
        return
      }
      // eslint-disable-next-line no-console
      console.log(this.total, payload)
      this.makePayment(payload)
    },
  },
}
</script>

<template>
  <div>
    <div class="dropin-container"></div>
    <BaseButton
      :disabled="!payEnabled || loading"
      :loading="loading"
      @click="onClick"
    >
      Pay
    </BaseButton>
  </div>
</template>

<style lang="scss">
@import '@design';

.braintree-heading {
  display: none;
}
</style>
